import React from 'react';
import PropTypes from 'prop-types';
import documentStyles from '../../Document.scss';
import styleVariables from '../../../variables';
import { Icon } from 'semantic-ui-react';

const Actions = class Actions extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    children: PropTypes.node.isRequired,
    windowDimensions: PropTypes.object.isRequired
  };

  render() {
    const isLargeScreen = this.props.windowDimensions.width >= 1280;
    return (
      <div>
        {React.cloneElement(this.props.children, {
          selection: true,
          floated: isLargeScreen ? 'left' : null,
          divided:
            this.props.windowDimensions.width < styleVariables.tabletBreakpoint,
          horizontal:
            this.props.windowDimensions.width >=
              styleVariables.tabletBreakpoint &&
            this.props.windowDimensions.width < 1280,
          relaxed: !isLargeScreen,
          style: { margin: 0 }
        })}
        {this.props.windowDimensions.width < styleVariables.tabletBreakpoint &&
          <div className={documentStyles.mobileActionMenuClose} onClick={this.props.onClose}>
            <Icon name='close' />
            Close
          </div>}
      </div>
    );
  }
};

export default Actions;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Actions/Actions.js